export default "__VITE_ASSET__CNzlGkcK__"